<div class="modal-header">
  <h4 class="modal-title">Multiple Logins Detected</h4>
</div>
<div class="modal-body">
  Another Active Session using this Login has been detected. Connect can only
  work with one active session per login. Would you like to keep this session?
  Note that keeping this session will log out all other sessions immediately.
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-primary mx-1" (click)="keep()">
    Keep this Session
  </button>
  <button type="button" class="btn btn-secondary mx-1" (click)="close()">
    Close this Session
  </button>
</div>
